import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as ReportParameterActions from './report-dbt-metadata.actions';
import { ReportClientService } from '@mode/shared/data-access-webapp';
import { of } from 'rxjs';

@Injectable()
export class ReportDbtMetadataEffects {
  loadReportDbtMetadata$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReportParameterActions.loadReportDbtMetadata),
      switchMap((action) => this.reportClientService.getReportDbtMetadata(action.accountId, action.reportToken)),
      map((dbtMetadata) => ReportParameterActions.loadReportDbtMetadataSuccess({ dbtMetaData: dbtMetadata })),
      catchError((error) => of(ReportParameterActions.loadReportDbtMetadataFailure({ error })))
    );
  });

  constructor(
    private actions$: Actions,
    private reportClientService: ReportClientService
  ) {}
}
